import {Fill, Stroke, Style} from "ol/style";
import {mixColors} from "../functions/colors.functions";

const color1 = '#FFFFFF';
const color3 = '#009966';
const color2 = mixColors(color1, color3, 50);

const colorValues = [
    mixColors(color1, color2, 0),
    mixColors(color1, color2, 50),
    mixColors(color1, color2, 100),
    mixColors(color2, color3, 50),
    mixColors(color2, color3, 0),
];
const colorSteps = [
    100,
    80,
    60,
    40,
    20
];

export const getStyle = (value, customColors, customSteps) => {
    customColors = customColors || colorValues;
    customSteps = customSteps || colorSteps;

    const defaultColor = customColors[customColors.length - 1];
    let color = defaultColor;
    for (let i = 0; i <= customSteps.length - 1; i++) {
        if (+value >= +customSteps[i] && +value <= +customSteps[i+1]) {
            color = customColors[i] || defaultColor;
            break;
        }
    }
    return new Style({
        fill: new Fill({
            color: color
        }),
    });
}

export const getDefaultStyle = () => {
    return new Style({
        fill: new Fill({
            color: '#CCC'
        }),
    });
}

// export const baseStyle = new Style({
//     fill: new Fill({
//         color: '#CCCCCC'
//     }),
//     text: new Text({
//         font: '12px Arial, sans-serif',
//         fill: new Fill({
//             color: '#006699'
//         }),
//         stroke: new Stroke({
//             color: '#FFFFFF',
//             width: 3
//         })
//     })
// });

// export const enhancedStyle = new Style({
//     stroke: new Stroke({
//         color: '#FFFFFF',
//         width: 1
//     })
// });


export const provinceHlStyle = new Style({
    fill: new Fill({
        color: 'transparent'
    }),
    stroke: new Stroke({
        color: '#FFFFFF',
        width: 4
    })
});
